import React, { useState } from 'react';
import axios from 'axios';
import Button from '@mui/material/Button';
import SendIcon from '@mui/icons-material/Send';

const commonButtonStyle = (disabled) => ({
  width: '25%',
  background: disabled ? '' : '#1d75de', // disabledの場合は背景色をクリア
  padding: '10px 20px',
  color: disabled ? '' : 'white', // disabledの場合は文字色をクリア
  fontWeight: 'bold',
  border: disabled ? '' : '1px solid white', // disabledの場合はボーダーをクリア
});

const NextButtonStyle = (disabled) => ({
  width: '25%',
  background: disabled ? '' : '#1d75de', // disabledの場合は背景色をクリア
  padding: '10px 20px',
  color: disabled ? '' : 'white', // disabledの場合は文字色をクリア
  fontWeight: 'bold',
  border: disabled ? '' : '1px solid white', // disabledの場合はボーダーをクリア
});

const SubmitDetailComponent = ({ setIsLoading, conversation, setConversation, setShowDetailComponent, setErrorMessage, setTypingIndex, setCurrentMessage, setCurrentMessageIndex }) => {
  const [isButtonDisabled, setIsButtonDisabled] = useState({
    fleshout: false,
    simplify: false,
    paraphrase: false,
    next: false,
  });

  // APIリクエストを送信する関数
  const handleApiRequest = async (buttonKey) => {

    setIsLoading(true); // ローディング開始
    // すぐにボタンを無効にする
    setIsButtonDisabled((prevState) => ({
      ...prevState,
      [buttonKey]: true,
    }));

    // ボタンに応じたAPIエンドポイント
    const apiEndpoint = {
      fleshout: 'fleshout-endpoint',
      simplify: 'simplify-endpoint',
      paraphrase: 'paraphrase-endpoint',
    }[buttonKey];

    const apiBaseURL = process.env.REACT_APP_API_URL || 'https://hangul-match.com/';
    const apiUrl = `${apiBaseURL}api/${apiEndpoint}`;
    const token = localStorage.getItem('authToken');
    const headers = {
      Authorization: `Bearer ${token}`
    };
    try {
      const response = await axios.post(apiUrl, { conversation }, { headers });
      console.log(response.data);
      setConversation(response.data.conversation);
    } catch (error) {
      console.error('メッセージの送信に失敗しました', error);
      console.error('APIリクエストに失敗しました', error);
      // エラーが発生した場合はボタンを再度有効にする
      setIsButtonDisabled((prevState) => ({
        ...prevState,
        [buttonKey]: false,
      }));
    } finally {
      setIsLoading(false); // ローディング終了
    }
  }

  const handleNextChatbot = (buttonKey) => {
    setIsLoading(true);
    setConversation([]);
    setCurrentMessage(''); // タイプライターの現在メッセージをリセット
    setCurrentMessageIndex(0); // タイプライターのメッセージインデックスをリセット
    setTypingIndex(0); // タイプライターのタイピングインデックスをリセット

    setIsButtonDisabled((prevState) => ({
      ...prevState,
      [buttonKey]: true,
    }));
    // 新しいトピックを生成するAPIリクエストを送信
    const token = localStorage.getItem('authToken');
    
    const apiBaseURL = process.env.REACT_APP_API_URL || 'https://hangul-match.com/';
    const apiUrl = `${apiBaseURL}api/generate-topic`;
    axios.get(apiUrl, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }).then(response => {
      setConversation(response.data.conversation);
      setIsLoading(false);
      setShowDetailComponent(false);
    }).catch(error => {
      if (error.response && error.response.status === 403) {
        // エラーメッセージを表示するなど、特定の処理を行う
        console.error('Error message:', error.response.data.message);
        setErrorMessage(error.response.data.message);
        setIsLoading(false);
        setShowDetailComponent(false);
      } else {
        console.error('There has been a problem with your fetch operation:', error)
      }
    });
  };


  return (
    <>
      <Button variant="outlined"
        color="success"
        endIcon={<SendIcon />}
        disabled={isButtonDisabled.fleshout}
        onClick={() => handleApiRequest('fleshout')}
        style={commonButtonStyle(isButtonDisabled.fleshout)}
      >肉付け</Button>
      <Button variant="outlined"
        color="success"
        endIcon={<SendIcon />}
        disabled={isButtonDisabled.simplify}
        onClick={() => handleApiRequest('simplify')}
        style={commonButtonStyle(isButtonDisabled.simplify)}
      >シンプル</Button>
      <Button variant="outlined"
        endIcon={<SendIcon />}
        disabled={isButtonDisabled.paraphrase}
        onClick={() => handleApiRequest('paraphrase')}
        style={commonButtonStyle(isButtonDisabled.paraphrase)}
      >言い換え</Button>
      {/* "次の質問へ" ボタンに関する処理が未定義なので、適宜追加してください */}
      <Button variant="outlined"
        endIcon={<SendIcon />}
        disabled={isButtonDisabled.next}
        onClick={() => handleNextChatbot('next')}
        style={NextButtonStyle(isButtonDisabled.next)}
      >次の質問</Button>
    </>
  );
}

export default SubmitDetailComponent;
